import React from "react";
import { chakra, useMultiStyleConfig, useRadio, useRadioGroupContext, } from "@chakra-ui/react";
import Balancer from "@hightouchio/react-wrap-balancer";
export function Radio({ isDisabled, label, badge, description, value, }) {
    const group = useRadioGroupContext();
    const { getRootProps, getRadioProps, getLabelProps, getInputProps } = useRadio({
        isChecked: group.value === value,
        isFocusable: group.isFocusable,
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        isDisabled: isDisabled || group.isDisabled,
        name: group.name,
        value,
        onChange: group.onChange,
    });
    const styles = useMultiStyleConfig("Radio");
    return (React.createElement(chakra.div, null,
        React.createElement(chakra.div, { __css: styles["container"] },
            React.createElement(chakra.label, { __css: styles["radio"], ...getRootProps() },
                React.createElement("input", { ...getInputProps() }),
                React.createElement(chakra.svg, { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", __css: styles["control"], ...getRadioProps() },
                    React.createElement("rect", { x: "0.5", y: "0.5", width: "15", height: "15", rx: "7.5" }),
                    React.createElement("circle", { cx: "8", cy: "8", r: "3.2" }),
                    React.createElement("rect", { x: "0.5", y: "0.5", width: "15", height: "15", rx: "7.5", fill: "none" })),
                label && (React.createElement(chakra.span, { __css: styles["label"], ...getLabelProps() }, label))),
            label && badge),
        description && (React.createElement(chakra.p, { __css: styles["description"] },
            React.createElement(Balancer, { ratio: 0.65 }, description)))));
}
